import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Checkbox } from "@mui/material";

export const MySelect = (props) => {
  const [value, setValue] = React.useState(props.value);
  const handleChange = (event, child) => {
    let result = event.target.value.filter((item) => item.value != "");
    const option = child.props.value;
    const isItemDiselected = value.find((item) => item.key == option.key) !== undefined;
    if (isItemDiselected) {
      result = value.filter((p) => p.key !== option.key);
    }
    setValue(result);
    props.onChange(result);
  };
  return (
    <FormControl size={props.size ? props.size : "medium"} variant="outlined" style={{ width: "100%", margin: "1rem 0", ...props.style }}>
      <InputLabel htmlFor="outlined-native-simple">{props.label}</InputLabel>
      <Select
        aria-label={props.label}
        multiple
        value={value}
        onChange={handleChange}
        renderValue={(selected) => selected.map((item) => item.value).join(", ")}
        label={props.label}
        inputProps={{
          id: "outlined-native-simple",
        }}
      >
        {props.options.map((option) => (
          <MenuItem key={option.key} value={option}>
            <Checkbox className="margin right-1 padding-0" checked={value.find((item) => item.key == option.key) !== undefined} />
            {option.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
